import { render, staticRenderFns } from "./Attemptquestion.vue?vue&type=template&id=332fc446&scoped=true"
import script from "./Attemptquestion.vue?vue&type=script&lang=js"
export * from "./Attemptquestion.vue?vue&type=script&lang=js"
import style0 from "./Attemptquestion.vue?vue&type=style&index=0&id=332fc446&prod&scoped=true&lang=css"
import style1 from "./Attemptquestion.vue?vue&type=style&index=1&id=332fc446&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332fc446",
  null
  
)

export default component.exports